/* Wedding bands (snippets/joy-alyans.liquid, owner 2026-10-17): one page per design with both rings. The pair is the
   default; each ring has its own width (where the design offers several), gram and size, and free engraving; one ring
   can be bought on its own; a link to one ring (?variant=, as a Google Shopping item) opens on that ring alone with its
   own price. The product's options are the ring (first value: hers), "5 mm · 4 gr" and the ayar. This
   keeps the form's variant (the first ring in the cart) and the price block current, and gives joy-product.js the
   cart lines (addToCart posts both rings in one request, linked by a hidden _alyans token). */
(() => {
  'use strict';
  const number = (text, unit) => {
    const match = String(text).match(new RegExp(`(\\d+(?:[.,]\\d+)?)\\s*${unit}`, 'i'));
    return match ? Number(match[1].replace(',', '.')) : null;
  };

  function setup(product) {
    const box = product.querySelector('[data-alyans]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = 'true';
    let data;
    try { data = JSON.parse(box.querySelector('[data-alyans-data]').textContent); } catch (error) { return; }
    const t = data.t;
    const money = (cents) => {
      const [whole, fraction] = (cents / 100).toFixed(2).split('.');
      const grouped = (separator) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      return (data.moneyFormat || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (match, kind) => {
        if (kind === 'amount_with_comma_separator') return `${grouped('.')},${fraction}`;
        if (kind === 'amount_no_decimals_with_comma_separator') return grouped('.');
        if (kind === 'amount_no_decimals') return grouped(',');
        return `${grouped(',')}.${fraction}`;
      });
    };

    // Variants: ring value (hers first), width, gram, ayar.
    const ringValues = [...new Set(data.variants.map((v) => v[1]))];
    const roles = { her: ringValues[0], his: ringValues[1] || ringValues[0] };
    const variants = data.variants.map(([id, ring, wg, ayar, price, available]) => ({
      id, ring, wg, ayar, price, available, width: number(wg, 'mm'), gram: number(wg, 'g')
    }));
    const ayars = [...new Set(variants.map((v) => v.ayar))];
    const find = (ring, width, gram, ayar) => variants.find((v) => v.ring === ring && v.width === width && v.gram === gram && v.ayar === ayar);
    const widthsOf = (ring) => [...new Set(variants.filter((v) => v.ring === ring).map((v) => v.width))].sort((a, b) => a - b);
    // The grams of one width (owner 2026-10-31: at least 1 g per mm, up to 3 g more, so each width has its own range).
    const gramsOf = (ring, width) => [...new Set(variants.filter((v) => v.ring === ring && v.width === width).map((v) => v.gram))].sort((a, b) => a - b);
    const gramText = (g) => `${String(g).replace('.', ',')} ${/gr/i.test(variants[0].wg) ? 'gr' : 'g'}`;

    const first = variants.find((v) => v.id === data.selected) || variants.find((v) => v.available) || variants[0];
    const ringState = (ring, gram) => {
      const widths = widthsOf(ring);
      const width = widths.includes(first.width) ? first.width : widths[0];   // else the design's own width
      const grams = variants.filter((v) => v.ring === ring && v.width === width && v.ayar === first.ayar).map((v) => v.gram);
      const pick = grams.includes(gram) ? gram : grams.find((g) => g >= gram) || grams[grams.length - 1];
      return { width, gram: pick, size: data.sizeStandard, engrave: '', font: '', fontKey: 'script' };
    };
    const linkedRing = first.ring === roles.his && roles.his !== roles.her ? 'his' : 'her';
    const state = {
      buy: data.fromLink ? linkedRing : 'pair',
      ayar: first.ayar,
      colour: data.colours[0] || '',
      rings: {
        her: ringState(roles.her, first.ring === roles.her ? first.gram : 4),
        his: ringState(roles.his, linkedRing === 'his' ? first.gram : 5)
      }
    };
    if (data.sizeStandard && state.rings.his) {
      // A man's ring is usually larger: open on the standard size plus six (14 → 20), or the US equivalent (7 → 9½).
      const index = data.sizes.indexOf(data.sizeStandard);
      const step = data.sizeStandard === '7' ? 5 : 6;
      if (index >= 0 && data.sizes[index + step]) state.rings.his.size = data.sizes[index + step];
    }
    const chosenRings = () => (state.buy === 'pair' ? ['her', 'his'] : [state.buy]);
    const variantOf = (key) => find(roles[key], state.rings[key].width, state.rings[key].gram, state.ayar);

    const chips = (legend, chosen, values, label, isOn, pick, disabled = () => false) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'option-group option-chips';
      fieldset.innerHTML = '<div class="option-heading"><legend></legend></div><div class="chips"></div>';
      fieldset.querySelector('legend').innerHTML = `${legend} <span class="option-chosen"></span>`;
      fieldset.querySelector('.option-chosen').textContent = chosen;
      values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'chip alyans-chip';
        button.innerHTML = '<span></span>';
        button.firstChild.textContent = label(value);
        button.disabled = disabled(value);
        button.setAttribute('aria-pressed', String(isOn(value)));
        button.addEventListener('click', () => { pick(value); render(); });
        fieldset.querySelector('.chips').append(button);
      });
      return fieldset;
    };

    const sizeRow = (ring) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'option-group option-chips size-row-group';
      fieldset.innerHTML = `<div class="option-heading"><legend>${data.sizeLabel} <span class="option-chosen"></span></legend><button type="button" class="size-guide-link" data-size-guide-open></button></div><div class="alyans-sizes"></div>`;
      fieldset.querySelector('.option-chosen').textContent = ring.size;
      const guideButton = fieldset.querySelector('[data-size-guide-open]');
      if (product.querySelector('[data-size-guide]') && t.sizeGuide) guideButton.textContent = t.sizeGuide;
      else guideButton.remove();
      const row = fieldset.querySelector('.alyans-sizes');
      data.sizes.forEach((size) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'chip alyans-chip size-chip';
        button.setAttribute('aria-pressed', String(size === ring.size));
        button.innerHTML = '<span></span>';
        button.firstChild.textContent = size;
        if (size === data.sizeStandard) {
          const small = document.createElement('small');
          small.textContent = t.standard;
          button.firstChild.append(small);
        }
        button.addEventListener('click', () => {
          if (row.dataset.dragged) return;   // the end of a mouse drag is not a choice
          ring.size = size;
          render();
        });
        row.append(button);
      });
      // Desktop: drag the sizes with the mouse like the other products' size row (joy-product.js), then settle on the
      // nearest size. The row is rebuilt on every choice, so the pointer is captured on the row (no window listeners).
      row.classList.add('size-row-track');
      // A chip's left edge in the row's scroll coordinates (whatever the row's offsetParent is).
      const at = (chip) => chip.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft;
      let drag = null;
      row.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, left: row.scrollLeft, moved: false, id: event.pointerId };
        delete row.dataset.dragged;
      });
      row.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 5) return;
        if (!drag.moved) {
          drag.moved = true;
          row.setPointerCapture(drag.id);
          row.classList.add('is-dragging');
        }
        row.scrollLeft = drag.left - distance;
      });
      const release = () => {
        if (!drag) return;
        const moved = drag.moved;
        drag = null;
        if (!moved) return;
        row.dataset.dragged = '1';
        setTimeout(() => { delete row.dataset.dragged; }, 0);
        const middle = row.scrollLeft + row.clientWidth / 2;
        const nearest = [...row.children].reduce((best, chip) => (!best || Math.abs(at(chip) + chip.offsetWidth / 2 - middle)
          < Math.abs(at(best) + best.offsetWidth / 2 - middle) ? chip : best), null);
        if (nearest) row.scrollTo({ left: at(nearest) - (row.clientWidth - nearest.offsetWidth) / 2, behavior: 'smooth' });
        setTimeout(() => row.classList.remove('is-dragging'), 350);
      };
      row.addEventListener('pointerup', release);
      row.addEventListener('pointercancel', release);
      // Arrows either side when the sizes do not fit, like the ring size row on other products; each shows only while
      // there is more to see on its side.
      const arrows = box.querySelector('[data-alyans-arrows]')?.content;
      if (arrows) {
        const line = document.createElement('div');
        line.className = 'size-row';
        row.replaceWith(line);
        const [previous, next] = [...arrows.cloneNode(true).querySelectorAll('[data-size-row-step]')];
        line.append(previous, row, next);
        const update = () => {
          const overflow = row.scrollWidth > row.clientWidth + 2;
          previous.hidden = !overflow || row.scrollLeft <= 2;
          next.hidden = !overflow || row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
        };
        [previous, next].forEach((button) => button.addEventListener('click', () => {
          row.scrollBy({ left: Number(button.dataset.sizeRowStep) * row.clientWidth * 0.6, behavior: 'smooth' });
        }));
        row.addEventListener('scroll', update, { passive: true });
        requestAnimationFrame(update);
      }
      requestAnimationFrame(() => {
        const on = row.querySelector('[aria-pressed="true"]');
        if (on) row.scrollLeft = at(on) - (row.clientWidth - on.offsetWidth) / 2;
      });
      return fieldset;
    };

    const card = (key) => {
      const ring = state.rings[key];
      const name = roles[key];
      const variant = variantOf(key);
      const section = document.createElement('section');
      section.className = 'alyans-ring';
      section.innerHTML = '<h3><span></span><strong></strong></h3>';
      section.querySelector('h3 span').textContent = key === 'her' ? t.her : t.his;
      section.querySelector('h3 strong').textContent = variant ? money(variant.price) : '';
      const widths = widthsOf(name);
      if (widths.length > 1) {
        section.append(chips(t.width, `${ring.width} mm`, widths, (w) => `${w} mm`, (w) => w === ring.width, (w) => {
          ring.width = w;
          if (!find(name, w, ring.gram, state.ayar)) ring.gram = variants.filter((v) => v.ring === name && v.width === w && v.ayar === state.ayar).map((v) => v.gram).sort((a, b) => a - b)[0];
        }));
      }
      // Grams on one line (owner 2026-10-17): the chips show the number, the heading keeps the unit.
      const gramRow = chips(t.gram, gramText(ring.gram), gramsOf(name, ring.width), (g) => (/gr/i.test(variants[0].wg) ? String(g).replace('.', ',') : String(g)), (g) => g === ring.gram,
        (g) => { ring.gram = g; }, (g) => !find(name, ring.width, g, state.ayar)?.available);
      gramRow.classList.add('alyans-grams');
      section.append(gramRow);
      if (t.gramNote && key === chosenRings()[0]) {
        const note = document.createElement('p');
        note.className = 'option-note';
        note.textContent = t.gramNote;
        if (t.guideUrl) {
          const link = document.createElement('a');
          link.href = t.guideUrl;
          link.textContent = t.guideLink;
          note.append(' ', link);
        }
        section.append(note);
      }
      section.append(sizeRow(ring));
      // Free engraving with the page's builder (preview and font); the shared dialog saves into this ring's box.
      const template = box.querySelector('[data-alyans-engrave]');
      if (data.engrave && template) {
        const engrave = template.content.firstElementChild.cloneNode(true);
        const text = engrave.querySelector('[data-engrave-text-input]');
        const font = engrave.querySelector('[data-engrave-font-input]');
        text.value = ring.engrave;
        font.value = ring.font;
        font.dataset.font = ring.fontKey;
        engrave.querySelector('[data-engrave-summary]').hidden = !ring.engrave;
        engrave.querySelector('.engrave-add').hidden = Boolean(ring.engrave);
        engrave.querySelector('[data-engrave-summary-text]').textContent = ring.engrave ? `“${ring.engrave}” · ${ring.font}` : '';
        engrave.addEventListener('joy:engraving', () => {
          ring.engrave = text.value.trim();
          ring.font = ring.engrave ? font.value : '';
          ring.fontKey = font.dataset.font || 'script';
        });
        section.append(engrave);
      }
      if (data.noResize && key === 'her') {
        const note = document.createElement('p');
        note.className = 'option-note';
        note.textContent = t.noResize;
        section.append(note);
      }
      return section;
    };

    // The form's variant is the first ring going to the cart; the price block shows the total (the pair with its discount).
    const syncForm = () => {
      const keys = chosenRings();
      const lines = keys.map(variantOf);
      const ready = lines.every((v) => v && v.available);
      const main = lines[0];
      const result = product.querySelector('[data-variant-result]');
      if (result && main) {
        result.dataset.variantId = ready ? main.id : '';
        result.dataset.available = String(ready);
      }
      const input = product.querySelector('[data-variant-input]');
      if (input && main) input.value = main.id;
      const installments = product.querySelector('[data-installments-variant]');
      if (installments && main && installments.value !== String(main.id)) {
        installments.value = main.id;
        installments.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Shop Pay's instalment line knows one variant only: shown for one ring, hidden for the pair.
      const terms = product.querySelector('.installments-terms');
      if (terms) terms.hidden = keys.length === 2;
      // During the opening offer each ring has its own discount, which in the cart beats the pair discount (owner
      // 2026-10-23): the pair price is then the plain total, and the offer line under it gives the cart's price.
      const offerLine = product.querySelector('[data-price-offer]');
      const offer = offerLine && Number(offerLine.dataset.offerEnds) * 1000 > Date.now() ? data.offerPercent : 0;
      const sum = lines.reduce((total, v) => total + (v ? v.price : 0), 0);
      const total = sum - (keys.length === 2 && !offer ? data.pairDiscount : 0);
      const price = product.querySelector('[data-main-price]');
      if (price) price.textContent = money(total);
      if (offerLine && offer) {
        offerLine.textContent = t.offerLine.replace('[percent]', offer).replace('[price]', money(Math.round(sum * (100 - offer) / 100)).replace(/[.,]00(?!\d)/, ''))
          + (data.offerUntil ? ` · ${data.offerUntil}` : '');
      }
      // The taksit line under the price (snippets/joy-price.liquid) splits the ring's or the pair's price.
      const taksit = product.querySelector('[data-price-taksit]');
      if (taksit && taksit.dataset.taksitTemplate) {
        const count = Number(taksit.dataset.taksitCount) || 3;
        // During the opening offer the cart charges the discounted total (the offer line's price).
        const base = offer ? Math.round(sum * (100 - offer) / 100) : total;
        taksit.innerHTML = taksit.dataset.taksitTemplate.replace('[amount]', money(Math.floor(base / count)).replace(/[.,]00(?!\d)/, ''));
      }
      // The bank transfer line (snippets/joy-price.liquid, absent during an offer) follows the ring's or the pair's price.
      const cash = product.querySelector('[data-price-cash]');
      if (cash && cash.dataset.cashTemplate) {
        const amount = Math.floor(total * (100 - Number(cash.dataset.cashPercent)) / 100);
        cash.innerHTML = cash.dataset.cashTemplate.replace('[amount]', money(amount).replace(/[.,]00(?!\d)/, ''));
      }
      const unit = product.querySelector('[data-product-price] .price-unit');
      // One short line under the pair price (owner 2026-10-17): "1.500 TL Çift İndirimi", no decimals.
      const saving = data.pairDiscount && !offer ? t.pairNote.replace('[amount]', money(data.pairDiscount).replace(/[.,]00(?!\d)/, '')) : t.pairUnit;
      const unitText = keys.length === 2 ? saving : t.singleUnit;
      if (unit) unit.textContent = unitText;
      else if (price) {
        const span = document.createElement('span');
        span.className = 'price-unit';
        span.textContent = unitText;
        price.after(span);
      }
      product.syncPurchase?.();
    };

    product.alyansItems = () => {
      const token = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
      return chosenRings().map((key) => {
        const ring = state.rings[key];
        const properties = { [t.ring]: key === 'her' ? t.her : t.his, [data.sizeLabel]: ring.size };
        if (state.colour) properties[data.colourLabel] = state.colour;
        if (ring.engrave.trim()) {
          properties[data.engraveKey] = ring.engrave.trim();
          if (ring.font) properties[data.engraveFontKey] = ring.font;
        }
        // Also on one ring: each add stays its own line, within the per-line maximum (no merging into a 6th band).
        properties._alyans = token;
        return { id: variantOf(key).id, quantity: 1, properties };
      });
    };

    // The buy-now confirmation and the WhatsApp message list each ring.
    product.alyansSummary = () => chosenRings().map((key) => {
      const ring = state.rings[key];
      const variant = variantOf(key);
      const parts = [variant ? variant.wg : '', state.ayar, `${data.sizeLabel} ${ring.size}`];
      if (state.colour) parts.push(state.colour);
      if (ring.engrave.trim()) parts.push(`${data.engraveKey}: ${ring.engrave.trim()}${ring.font ? ` (${ring.font})` : ''}`);
      return [key === 'her' ? t.her : t.his, parts.filter(Boolean).join(' · ')];
    });
    product.alyansEngraved = () => chosenRings().some((key) => state.rings[key].engrave.trim());

    function render() {
      const keys = chosenRings();
      box.replaceChildren(box.querySelector('[data-alyans-data]'), box.querySelector('[data-alyans-engrave]') || '', box.querySelector('[data-alyans-arrows]') || '');
      // One line of three (owner 2026-10-17): the chips are short, the heading names the choice in full.
      const buyRow = chips(t.buy, { pair: t.pair, her: t.onlyHer, his: t.onlyHis }[state.buy], ['pair', 'her', 'his'],
        (value) => ({ pair: t.buyPair, her: t.buyHer, his: t.buyHis }[value]), (value) => value === state.buy, (value) => { state.buy = value; });
      buyRow.classList.add('alyans-buy');
      box.append(buyRow);
      box.append(chips(t.ayar, state.ayar, ayars, (a) => a, (a) => a === state.ayar, (a) => { state.ayar = a; }));
      if (data.colours.length) {
        box.append(chips(data.colourLabel, state.colour, data.colours, (c) => c, (c) => c === state.colour,
          (c) => { state.colour = c; product.showColour?.(c); }));   // the gallery shows that colour's photos (alt text)
      }
      keys.forEach((key) => box.append(card(key)));
      syncForm();
    }
    render();
  }

  const start = () => document.querySelectorAll('joy-product').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
